import React from 'react';
import { Button } from 'src/components/UI';
import { page_favorite_selection_bottom_right_button } from 'src/utils/stringConstants';
import styles from './styles.module.scss';

interface FavoriteSelectionFooterProps {
    // variant: 'enrollment' | 'manage-favorites';
    selectedCategoriesLength: number;
    handleConfirm: () => void;
    isLoading: boolean;
}

function FavoriteSelectionFooter({
    selectedCategoriesLength,
    handleConfirm,
    isLoading,
}: FavoriteSelectionFooterProps) {
    return (
        <div className={styles.footer}>
            <Button
                disabled={!(selectedCategoriesLength > 0) || isLoading}
                onClick={handleConfirm}
                loading={isLoading}
                breakpoint={420}
            >
                {page_favorite_selection_bottom_right_button}
            </Button>
        </div>
    );
}

export default FavoriteSelectionFooter;
